import React from 'react';
import ReportingGiftCardsLedgerPage from '../components/ReportingGiftCardsLedgerPage';

const ReportingGiftCardsLedgerApp = (props) => (
  <ReportingGiftCardsLedgerPage {...props} />
);

export default ReportingGiftCardsLedgerApp;
